import { environment } from '@env/environment';

export const CONFIG = {
  MOBILE_MEDIA_QUERY: 'screen and (max-width: 768px)',
  TABLET_MEDIA_QUERY: 'screen and (min-width: 768px) and (max-width: 1024px)',
  MONITOR_MEDIA_QUERY: 'screen and (min-width: 1024px)',
  WIDE_MONITOR_MEDIA_QUERY: 'screen and (min-width: 1280px)',
  DEFAULT_COMPANY_LOGO: `${environment.ASSET_URL}/images/Reengage_White.svg`,
};
// https://wellyou.eu/wp-content/uploads/2021/03/logo.png
